import Admin from "pages/LandingPages/Admin";
export default function AdminPage() {
  return <Admin />;
}
